module.exports = __webpack_public_path__ + "img/intro.d5a0f45a.svg";